// The `meal_type` badge vocabulary — one copy, read by every surface that
// renders one.
//
// There were six identical copies of this map (browse, my_schedules, cookbook,
// the cooking view's tab bar, the recipe player, the builder's review list),
// which is how a vocabulary change lands on five screens out of six. Mirrors
// MEAL_TYPE_LABELS in back-end/schedule/meal_types.py.
//
// `side` accompanies a main and is not one. The builder gives it no slots, so
// it appears on browse, in the Cookbook and on a schedule the user deliberately
// locked one into — never in a week the app planned by itself.
export const MEAL_TYPE_BADGE = {
  main: { label: "Main", color: "#1565c0", bg: "#e3f2fd" },
  portable: { label: "To-go", color: "#6a1b9a", bg: "#f3e5f5" },
  snack: { label: "Snack", color: "#e65100", bg: "#fff3e0" },
  // Green, and distinct from the other three: a side sitting next to a main in
  // a list has to be tellable apart at a glance. 4.6:1 on its own background.
  side: { label: "Side", color: "#2e7d32", bg: "#e8f5e9" },
};

// Display order wherever the types are listed rather than looked up.
export const MEAL_TYPE_ORDER = ["main", "portable", "snack", "side"];

export const mealTypeLabel = (mealType) => MEAL_TYPE_BADGE[mealType]?.label || mealType;

export default MEAL_TYPE_BADGE;
